// extracted by mini-css-extract-plugin
export default {"propertyPageContainer":"PropertyPage_propertyPageContainer__dn5-Z","propertyMapContainer":"PropertyPage_propertyMapContainer__aptmi"};